import {
  BABY_CATEGORY,
  GRADUATION_CATEGORY,
  KIDS_BIRTHDAY_CATEGORY,
  WEDDING_CATEGORY,
} from '../utils/event_constants';
import {doesMatchEventCategory} from '../utils/event_utils';

// ICONS
export const AMAZON_AF_DEFAULT_DISK_IMAGE =
  'https://g0.evitecdn.com/apps/logos/third-party/amazon_logo_plain_large.png';

// URLS
// CREATE REGISTRY URLS
const AMAZON_AF_CREATE_REGISTRY_DEFAULT_URL =
  'https://www.amazon.com/registries?&linkCode=sl2&tag=web-tracking-20&linkId=0d246c463df5af11770708c6342988e4&language=en_US&ref_=as_li_ss_tl';
const AMAZON_AF_CREATE_REGISTRY_BABY_URL =
  'https://www.amazon.com/baby-reg?pd_rd_w=RUHW4&content-id=amzn1.sym.a81ccd24-fffd-40b7-aac6-9f5fc09645f5:amzn1.sym.a81ccd24-fffd-40b7-aac6-9f5fc09645f5&pf_rd_p=a81ccd24-fffd-40b7-aac6-9f5fc09645f5&pf_rd_r=DZ3DS2S8H00S9SRXZZS5&pd_rd_wg=7Hvcg&pd_rd_r=d6b3d27f-df01-4c39-8204-f555659bfb46&qid=1753814768&linkCode=sl2&tag=web-tracking-20&linkId=17e5cfc0f8612d8566cb76beae236742&language=en_US&ref_=as_li_ss_tl';
const AMAZON_AF_CREATE_REGISTRY_KIDS_BIRTHDAY_URL =
  'https://www.amazon.com/registries/birthday?pd_rd_w=RUHW4&content-id=amzn1.sym.a81ccd24-fffd-40b7-aac6-9f5fc09645f5:amzn1.sym.a81ccd24-fffd-40b7-aac6-9f5fc09645f5&pf_rd_p=a81ccd24-fffd-40b7-aac6-9f5fc09645f5&pf_rd_r=DZ3DS2S8H00S9SRXZZS5&pd_rd_wg=7Hvcg&pd_rd_r=d6b3d27f-df01-4c39-8204-f555659bfb46&qid=1753814768&linkCode=sl2&tag=web-tracking-20&linkId=e1f35b779ef45c3d7230f8ac29124680&language=en_US&ref_=as_li_ss_tl';
const AMAZON_AF_CREATE_REGISTRY_WEDDING_URL =
  'https://www.amazon.com/wedding?pd_rd_w=RUHW4&content-id=amzn1.sym.a81ccd24-fffd-40b7-aac6-9f5fc09645f5:amzn1.sym.a81ccd24-fffd-40b7-aac6-9f5fc09645f5&pf_rd_p=a81ccd24-fffd-40b7-aac6-9f5fc09645f5&pf_rd_r=DZ3DS2S8H00S9SRXZZS5&pd_rd_wg=7Hvcg&pd_rd_r=d6b3d27f-df01-4c39-8204-f555659bfb46&qid=1753814768&linkCode=sl2&tag=web-tracking-20&linkId=362f3fb8209fecd2712e420c4f76898d&language=en_US&ref_=as_li_ss_tl';
// GIFT SHOP URLS
const AMAZON_AF_GIFT_SHOP_URL =
  'https://www.amazon.com/b?node=206764924011&linkCode=ll2&tag=web-tracking-20&linkId=7bd369ba5ece48f579e5f5df7b2f4940&language=en_US&ref_=as_li_ss_tl';
const AMAZON_AF_GIFT_SHOP_CA_URL = 'https://www.amazon.ca';
// PARTY SUPPLIES URLS
export const AMAZON_AF_PARTY_SUPPLIES_DEFAULT_URL =
  'https://www.amazon.com/s?k=party+supplies&language=en_US&crid=7C7ZO53DRQ1H&linkCode=sl2&linkId=fc6052477a785f178e05c9b4c62c7ad8&sprefix=party+supplie%2Caps%2C201&tag=web-tracking-20&ref=as_li_ss_tl';
const AMAZON_AF_PARTY_SUPPLIES_BABY_SHOWER_URL =
  'https://www.amazon.com/s?k=party+decorations+baby+shower&i=garden&language=en_US&crid=3IX1WG7KWAHQA&linkCode=sl2&linkId=fb2d51b10cf38f9953a50563d09bbfb6&sprefix=party+decorations+baby+shower%2Cgarden%2C153&tag=web-tracking-20&ref=as_li_ss_tl';
const AMAZON_AF_PARTY_SUPPLIES_GRADUATION_URL =
  'https://www.amazon.com/s?k=party+decorations&i=garden&rh=n%3A1055398%2Cp_n_feature_fourteen_browse-bin%3A723527011&dc&language=en_US&ds=v1%3AWYRlh%2BZzL5JfmyGSh2RzlDcQcwsJy6ScW75kCivHgmU&crid=28E3QEQ34WXBW&linkCode=sl2&linkId=00786453fce989127620aa3f1f7e900a&qid=1744918138&rnid=723519011&sprefix=party+decor%2Caps%2C161&tag=web-tracking-20&ref=as_li_ss_tl';
const AMAZON_AF_PARTY_SUPPLIES_KIDS_BIRTHDAY_URL =
  'https://www.amazon.com/s?k=party+decorations&i=garden&rh=n%3A1055398%2Cp_n_feature_fourteen_browse-bin%3A723522011&dc&language=en_US&ds=v1%3AeE7SaPyfm4M9qsBlBSCXxfIxfvX%2F%2FXg3j6STYKgb%2BSU&crid=28E3QEQ34WXBW&linkCode=sl2&linkId=c7e0502431a1fec999ab66e9e5e411d5&qid=1744918109&rnid=723519011&sprefix=party+decor%2Caps%2C161&tag=web-tracking-20&ref=as_li_ss_tl';
const AMAZON_AF_PARTY_SUPPLIES_WEDDING_URL =
  'https://www.amazon.com/s?k=party+decorations&rh=n%3A1055398%2Cp_n_feature_fourteen_browse-bin%3A723543011&dc&language=en_US&ds=v1%3Ab1zYq4oK3lfCeAi99j%2B%2B4bLdC3e1QzSySBN601RQMtw&crid=28E3QEQ34WXBW&linkCode=sl2&linkId=bd5dce32cb4edea09b1e0e9e74824255&qid=1744918072&rnid=723519011&sprefix=party+decor%2Caps%2C161&tag=web-tracking-20&ref=as_li_ss_tl';
const AMAZON_AF_PARTY_SUPPLY_DECORATIONS_URL =
  'https://www.amazon.com/s?k=party+supply+decorations&language=en_US&crid=3QC6V918B9Y1K&linkCode=sl2&linkId=d0eb2ebb2ac441f5d9bbafc19ea44d4c&sprefix=party+supply+decor%2Caps%2C298&tag=web-tracking-20&ref=as_li_ss_tl';

// TRACKING PARAMS
// TAGS
const AMAZON_AF_WEB_TAG = 'web-tracking-20';
const AMAZON_AF_CA_TAG = 'evitecomca-20';

const isCanadianEvent = (eventCountry: string) => eventCountry === 'CA';

const parseClassifiedCategory = (eventClassification: string) => {
  if (!eventClassification) return 'none';
  return eventClassification
    .split(' - ')
    .map((category) =>
      category
        .replace(/ /g, '_')
        .replace(/[^a-zA-Z0-9_]/g, '')
        .trim()
        .toLowerCase()
    )
    .join('-');
};

const setAscSourceParam = (amazonUrl: URL, eventClassification: string) => {
  const categoryParam = parseClassifiedCategory(eventClassification);
  amazonUrl.searchParams.set('asc_source', `${categoryParam}|noreg`);
};

const setHostName = (amazonUrl: URL, eventCountry: string) => {
  if (isCanadianEvent(eventCountry)) {
    amazonUrl.hostname = 'www.amazon.ca';
  }
};

const setTagParam = (amazonUrl: URL, eventCountry: string) => {
  const tagParamValue = isCanadianEvent(eventCountry) ? AMAZON_AF_CA_TAG : AMAZON_AF_WEB_TAG;
  amazonUrl.searchParams.set('tag', tagParamValue);
};

const addAmazonTrackingParams = (
  amazonUrl: string,
  eventClassification: string,
  eventCountry: string
) => {
  const url = new URL(amazonUrl);
  setHostName(url, eventCountry);
  setAscSourceParam(url, eventClassification);
  setTagParam(url, eventCountry);
  return url.toString();
};

export const getAmazonAffiliateGiftShopUrl = (
  eventClassification: string,
  eventCountry: string = 'US'
): string => {
  const giftShopUrl = isCanadianEvent(eventCountry)
    ? AMAZON_AF_GIFT_SHOP_CA_URL
    : AMAZON_AF_GIFT_SHOP_URL;
  return addAmazonTrackingParams(giftShopUrl, eventClassification, eventCountry);
};

export const getAmazonAffiliatePartySuppliesDecorationsUrl = (
  eventClassification: string,
  eventCountry: string = 'US'
): string =>
  addAmazonTrackingParams(
    AMAZON_AF_PARTY_SUPPLY_DECORATIONS_URL,
    eventClassification,
    eventCountry
  );

export const getAmazonAffiliatePartySuppliesUrl = (
  eventClassification: string,
  eventCountry: string = 'US'
): string => {
  let amazonUrl = AMAZON_AF_PARTY_SUPPLIES_DEFAULT_URL;
  if (doesMatchEventCategory(eventClassification, BABY_CATEGORY)) {
    amazonUrl = AMAZON_AF_PARTY_SUPPLIES_BABY_SHOWER_URL;
  } else if (doesMatchEventCategory(eventClassification, GRADUATION_CATEGORY)) {
    amazonUrl = AMAZON_AF_PARTY_SUPPLIES_GRADUATION_URL;
  } else if (doesMatchEventCategory(eventClassification, KIDS_BIRTHDAY_CATEGORY)) {
    amazonUrl = AMAZON_AF_PARTY_SUPPLIES_KIDS_BIRTHDAY_URL;
  } else if (doesMatchEventCategory(eventClassification, WEDDING_CATEGORY)) {
    amazonUrl = AMAZON_AF_PARTY_SUPPLIES_WEDDING_URL;
  }
  return addAmazonTrackingParams(amazonUrl, eventClassification, eventCountry);
};

export const getAmazonAffiliateCreateRegistryUrl = (
  eventClassification: string,
  eventCountry: string = 'US'
): string => {
  let amazonUrl = AMAZON_AF_CREATE_REGISTRY_DEFAULT_URL;
  if (doesMatchEventCategory(eventClassification, BABY_CATEGORY)) {
    amazonUrl = AMAZON_AF_CREATE_REGISTRY_BABY_URL;
  } else if (doesMatchEventCategory(eventClassification, KIDS_BIRTHDAY_CATEGORY)) {
    amazonUrl = AMAZON_AF_CREATE_REGISTRY_KIDS_BIRTHDAY_URL;
  } else if (doesMatchEventCategory(eventClassification, WEDDING_CATEGORY)) {
    amazonUrl = AMAZON_AF_CREATE_REGISTRY_WEDDING_URL;
  }
  return addAmazonTrackingParams(amazonUrl, eventClassification, eventCountry);
};
